import { app } from '../core/App';
import { PassengerJourney, PassengerDetails } from './levels/level';

export const PassengerState = {
  ReadyToSpawn: 'readyToSpawn',
  WaitingForPickup: 'waitingForPickup',
  OnRoute: 'onRoute',
  ReadyToDropOff: 'readyToDropOff',
  AtDestination: 'atDestination'
} as const;
export type PassengerStateKeys = keyof typeof PassengerState;
export type PassengerStateValues = typeof PassengerState[PassengerStateKeys];

export const PassengerIcon = {
  One: 'icon-passenger-1.png',
  Two: 'icon-passenger-2.png',
  Three: 'icon-passenger-3.png',
  Four: 'icon-passenger-4.png',
  Five: 'icon-passenger-5.png',
  Six: 'icon-passenger-6.png',
  Seven: 'icon-passenger-7.png',
  Eight: 'icon-passenger-8.png',
  Nine: 'icon-passenger-9.png',
  Ten: 'icon-passenger-10.png',
  Eleven: 'icon-passenger-11.png',
  Twelve: 'icon-passenger-12.png',
  Thirteen: 'icon-passenger-13.png',
  Fourteen: 'icon-passenger-14.png',
  Fifteen: 'icon-passenger-15.png',
  Sixteen: 'icon-passenger-16.png',
  Seventeen: 'icon-passenger-17.png',
  Eighteen: 'icon-passenger-18.png',
  Nineteen: 'icon-passenger-19.png',
  Twenty: 'icon-passenger-20.png'
} as const;
export type PassengerIconKeys = keyof typeof PassengerIcon;
export type PassengerIconValues = typeof PassengerIcon[PassengerIconKeys];

export const PassengerSprite = {
  One: 'passenger-1.png',
  Two: 'passenger-2.png',
  Three: 'passenger-3.png',
  Four: 'passenger-4.png',
  Five: 'passenger-5.png',
  Six: 'passenger-6.png',
  Seven: 'passenger-7.png',
  Eight: 'passenger-8.png',
  Nine: 'passenger-9.png',
  Ten: 'passenger-10.png',
  Eleven: 'passenger-11.png',
  Twelve: 'passenger-12.png',
  Thirteen: 'passenger-13.png',
  Fourteen: 'passenger-14.png',
  Fifteen: 'passenger-15.png',
  Sixteen: 'passenger-16.png',
  Seventeen: 'passenger-17.png',
  Eighteen: 'passenger-18.png',
  Nineteen: 'passenger-19.png',
  Twenty: 'passenger-20.png'
} as const;
export type PassengerSpriteKeys = keyof typeof PassengerSprite;
export type PassengerSpriteValues = typeof PassengerSprite[PassengerSpriteKeys];

export class Passenger {
  protected sprite: PassengerSpriteValues;
  protected icon: PassengerIconValues;
  protected pickupPoint: number;
  protected travelDistance: number;
  protected dropOffPoint: number;
  protected pickupBonus: number;
  protected dropOffBonus: number;
  protected distanceRate: number;
  protected state: PassengerStateValues;
  protected hasWhistled: boolean;

  constructor(passengerDetails: PassengerDetails, passengerJourney: PassengerJourney) {
    this.sprite = passengerJourney.sprite;
    this.icon = passengerJourney.icon;
    this.pickupPoint = passengerJourney.pickupDistance;
    this.travelDistance = passengerJourney.travelDistance;
    this.dropOffPoint = passengerJourney.pickupDistance + passengerJourney.travelDistance;
    this.pickupBonus = passengerJourney?.passengerPickupBonus ?? passengerDetails.defaultPassengerPickupBonus;
    this.dropOffBonus = passengerJourney?.passengerDropOffBonus ?? passengerDetails.defaultPassengerDropOffBonus;
    this.distanceRate = passengerJourney?.passengerDistanceRate ?? passengerDetails.defaultPassengerDistanceRate;

    this.state = PassengerState.ReadyToSpawn;
    this.hasWhistled = false;
  }

  get State() {
    return this.state;
  }

  get Sprite() {
    return this.sprite;
  }

  get Icon() {
    return this.icon;
  }

  get PickupPoint() {
    return this.pickupPoint;
  }

  get DropOffPoint() {
    return this.dropOffPoint;
  }

  get PickupBonus() {
    return this.pickupBonus;
  }

  get DropOffBonus() {
    return this.dropOffBonus;
  }

  get DistanceRate() {
    return this.distanceRate;
  }

  get HasWhistled() {
    return this.hasWhistled;
  }

  public spawned() {
    this.state = PassengerState.WaitingForPickup;
  }

  public whistle() {
    this.hasWhistled = true;
  }

  public pickedUp() {
    this.state = PassengerState.OnRoute;
  }

  public nearDropOff() {
    this.state = PassengerState.ReadyToDropOff;
  }

  public droppedOff() {
    this.state = PassengerState.AtDestination;
  }
}
